// Copyright (C) 2012 Minted Inc.
// All Rights Reserved
// CTAG:COMMUNITY:CHALLENGES

M.Model = M.Model || {};

/**
 * @class M.Model.DesignLike
 *
 * Models a design_like
 *
 * Note:
 *   is_liked: null = new like record
 *   is_liked: true = design is liked
 *   is_liked: false = design is unliked
 */

/*
  !! IMPORTANT !! DO NOT USE/INCOMPLETE CODE
  !! IMPORTANT !! DO NOT USE/INCOMPLETE CODE
  !! IMPORTANT !! DO NOT USE/INCOMPLETE CODE
*/
M.Model.DesignLike = Backbone.Model.extend({
  defaults: {
    is_liked: null
  },

  url : function() {
    return this.get('urlPaths')['designLikeUrlName'];
  }

});
